/* import __COLOCATED_TEMPLATE__ from './checkbox.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-checkbox';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_HOVER = `${CLASS_NAME}--hover`;
const CLASS_NAME_INLINE = `${CLASS_NAME}--inline`;

/** @type {object} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
};

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

/** @class */
class GlmCheckbox extends Component {
  @tracked isHovering = false;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
      this.args.disabled && CLASS_NAME_DISABLED,
      this.isHovering && CLASS_NAME_HOVER,
      this.args.inline && CLASS_NAME_INLINE,
      this.theme,
    )
  }

  get className() {
    return CLASS_NAME;
  }

  get theme() {
    const { theme } = this.args;
    return THEME_TO_CLASS_MAP[theme || THEMES.BLACK];
  }

  /**
   * @param {MouseEvent|KeyboardEvent} e
   */
  @action
  handleClick(e) {
    e.preventDefault();

    if (!this.args.disabled) {
      this.args.onclick?.(e);
    }
  }

  /**
   * @param {KeyboardEvent} e
   */
  @action
  handleKeyUp(e) {
    this.args.onkeyup?.(e);

    if (e.defaultPrevented) {
      return;
    }

    switch (e.key) {
      case 'Space':
      case 'Enter':
        e.preventDefault();

        this.handleClick(e);
        break;
    }
  }

  /**
   *
   */
  @action
  onMouseEnter() {
    this.isHovering = true;

    this.args.mouseenter?.();
  }

  /**
   *
   */
  @action
  onMouseLeave() {
    this.isHovering = false;

    this.args.mouseleave?.();
  }
}

export default GlmCheckbox;
